import Component from '@glimmer/component';
import { get } from '@ember/object';

export default class EmployeesDocumentReviewDropdownOptionComponent extends Component {
  get isUserDocumentTemplateEnabled() {
    const { userDocumentTemplate, reviewableUserDocumentTemplates } = this.args;
    return reviewableUserDocumentTemplates.isAny('identifier', get(userDocumentTemplate, 'identifier'));
  }
}
